console.log('🚀 Script Quick Buy activo y observando el DOM');

const observer = new MutationObserver(() => {
  const wrap = document.querySelector('.quick-buy-modal__gallery-wrapper');
  if (!wrap || wrap.dataset.wired) return;

  const prev = wrap.querySelector('.gallery-prev');
  const next = wrap.querySelector('.gallery-next');
  const productGallery = wrap.querySelector('product-gallery');

  if (!prev || !next || !productGallery) return;

  wrap.dataset.wired = '1';
  console.log('🎯 Quick Buy detectado, conectando flechas...');

  setTimeout(() => {
    const scrollArea =
      productGallery.shadowRoot?.querySelector('scroll-carousel') ||
      productGallery.querySelector('scroll-carousel') ||
      productGallery.shadowRoot?.querySelector('.product-gallery__media-list') ||
      productGallery.querySelector('.product-gallery__media-list');

    if (!scrollArea) {
      console.log('⚠️ No se encontró scroll-carousel dentro del product-gallery');
      return;
    }

    prev.addEventListener('click', () => {
      scrollArea.scrollBy({ left: -scrollArea.offsetWidth, behavior: 'smooth' });
      console.log('⬅️ Flecha izquierda clicada');
    });

    next.addEventListener('click', () => {
      scrollArea.scrollBy({ left: scrollArea.offsetWidth, behavior: 'smooth' });
      console.log('➡️ Flecha derecha clicada');
    });

    console.log('✅ Flechas conectadas correctamente');
  }, 600);
});

// observamos todo el body, incluido el shadow DOM cuando se inyecta el quick buy
observer.observe(document.body, { childList: true, subtree: true });
// Fix: indicator dots in related product cards not updating on gallery scroll
// Root cause: inline scripts inside product-recommendations are not executed
// when injected via DOMParser + importNode + replaceChildren.
(function () {
  'use strict';

  function initProductCardGallery(gallery) {
    if (gallery.dataset.indicatorInit) return; // avoid double init
    gallery.dataset.indicatorInit = '1';

    var wrapper = gallery.parentElement;
    if (!wrapper) return;

    var indicators = wrapper.querySelectorAll('.product-card__gallery-indicator');
    if (!indicators.length) return;

    function updateIndicators() {
      var slideWidth = gallery.children[0] ? gallery.children[0].offsetWidth : 0;
      if (!slideWidth) return;
      var currentIndex = Math.floor(gallery.scrollLeft / slideWidth);
      indicators.forEach(function (indicator, index) {
        indicator.classList.toggle('is-active', index === currentIndex);
      });
    }

    gallery.addEventListener('scroll', updateIndicators, { passive: true });
    gallery.addEventListener('scrollend', updateIndicators, { passive: true });
    updateIndicators();
  }

  // Init galleries already in DOM on page load
  document.querySelectorAll('.product-card__gallery[data-product-id]').forEach(initProductCardGallery);

  // Watch for galleries added dynamically via product-recommendations AJAX
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('product-card__gallery') && node.dataset.productId) {
          initProductCardGallery(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('.product-card__gallery[data-product-id]').forEach(initProductCardGallery);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();

/* ==========================================================================
   Search Drawer - Jacquemus-style top-down search
   ========================================================================== */
(function () {
  'use strict';

  var INITIAL_LIMIT = 20;
  var DEBOUNCE_MS = 300;
  var drawer, input, resultsContainer, loadingEl;
  var isOpen = false;
  var isExpanded = false;
  var isFullView = false;
  var debounceTimer = null;
  var allProducts = [];
  var currentQuery = '';
  var searchUrlBase = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root.replace(/\/+$/, '')
    : '') + '/search';

  function init() {
    drawer = document.getElementById('search-drawer');
    if (!drawer) return;

    input = drawer.querySelector('[data-search-input]');
    resultsContainer = drawer.querySelector('[data-search-results]');
    loadingEl = drawer.querySelector('[data-search-loading]');

    if (!input || !resultsContainer) return;

    bindEvents();
  }

  function bindEvents() {
    drawer.querySelectorAll('[data-search-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) close();
    });

    input.addEventListener('input', onInput);

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') e.preventDefault();
    });

    input.addEventListener('focus', function () {
      if (input.value.length >= 1 && !isExpanded) {
        expand();
      }
    });
  }

  function open() {
    if (isOpen) return;
    isOpen = true;
    isExpanded = false;
    isFullView = false;
    allProducts = [];

    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    setTimeout(function () {
      input.focus();
    }, 350);
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    isExpanded = false;
    isFullView = false;
    allProducts = [];

    drawer.classList.remove('is-open', 'is-expanded');
    document.body.style.overflow = '';

    input.value = '';
    resultsContainer.innerHTML = '';
    loadingEl.classList.remove('is-active');
    currentQuery = '';

    var cleanUrl = window.location.pathname;
    if (window.location.search) {
      var params = new URLSearchParams(window.location.search);
      params.delete('q');
      var newQs = params.toString();
      cleanUrl = newQs ? cleanUrl + '?' + newQs : cleanUrl;
    }
    history.replaceState(null, '', cleanUrl);
  }

  function expand() {
    if (isExpanded) return;
    isExpanded = true;
    drawer.classList.add('is-expanded');
  }

  function collapse() {
    if (!isExpanded) return;
    isExpanded = false;
    drawer.classList.remove('is-expanded');
  }

  function onInput() {
    var query = input.value.trim();
    clearTimeout(debounceTimer);

    if (isFullView) {
      isFullView = false;
      allProducts = [];
    }

    if (!query) {
      collapse();
      resultsContainer.innerHTML = '';
      loadingEl.classList.remove('is-active');
      var cleanUrl = window.location.pathname;
      history.replaceState(null, '', cleanUrl);
      return;
    }

    if (query.length >= 1) expand();
    updateUrl(query);

    debounceTimer = setTimeout(function () {
      fetchSuggest(query, INITIAL_LIMIT, renderInitial);
    }, DEBOUNCE_MS);
  }

  function updateUrl(query) {
    var url = searchUrlBase + '?q=' + encodeURIComponent(query);
    history.replaceState(null, '', url);
  }

  function fetchSuggest(query, limit, callback) {
    loadingEl.classList.add('is-active');
    var url = searchUrlBase + '?q=' + encodeURIComponent(query) + '&page=1&section_id=main-search';

    fetch(url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.text();
    })
    .then(function (html) {
      loadingEl.classList.remove('is-active');

      var temp = document.createElement('div');
      temp.innerHTML = html;

      var cards = temp.querySelectorAll('product-card');
      var productsHtml = [];
      cards.forEach(function (card) {
        productsHtml.push(card.outerHTML);
      });

      callback(productsHtml, [], query);
    })
    .catch(function () {
      loadingEl.classList.remove('is-active');
      resultsContainer.innerHTML = '<div class="search-drawer__empty">No results found for "' +
        escapeHtml(query) + '"</div>';
    });
  }

  function renderInitial(productsHtml, suggestions, query) {
    currentQuery = query;
    resultsContainer.innerHTML = '';

    if (productsHtml.length === 0) {
      resultsContainer.innerHTML = '<div class="search-drawer__empty">No results found for "' +
        escapeHtml(query) + '"</div>';
      return;
    }

    var html = '';
    html += '<div class="search-drawer__results-header">';
    html += '<span class="search-drawer__results-count">' + productsHtml.length + ' results</span>';
    html += '</div>';

    if (suggestions.length > 0) {
      html += '<div class="search-drawer__suggestions">';
      suggestions.forEach(function (q) {
        html += '<span class="search-drawer__suggestion-tag" data-search-tag>' +
          escapeHtml(q.text || q.term || q) + '</span>';
      });
      html += '</div>';
    }

    html += '<div class="search-drawer__products">' + productsHtml.join('') + '</div>';

    html += '<button type="button" class="search-drawer__view-all" data-view-all>' +
      'View all results</button>';

    resultsContainer.innerHTML = html;
    bindResultEvents(productsHtml, suggestions, query);
  }

  function loadFullView(query) {
    isFullView = true;
    allProducts = [];
    currentQuery = query;
    loadingEl.classList.add('is-active');

    fetchSearchPage(query, 1, function (cardsHtml, total) {
      loadingEl.classList.remove('is-active');

      var html = '';
      html += '<div class="search-drawer__results-header">';
      html += '<span class="search-drawer__results-count">' + total + ' results for "' + escapeHtml(query) + '"</span>';
      html += '</div>';

      html += '<div class="search-drawer__products">';
      html += cardsHtml.join('');
      html += '</div>';
      allProducts = cardsHtml;

      if (cardsHtml.length > 0 && total > cardsHtml.length) {
        html += buildLoadMore(query, 2, total - cardsHtml.length);
      }

      resultsContainer.innerHTML = html;

      if (cardsHtml.length > 0 && total > cardsHtml.length) {
        bindLoadMore(query, 2);
      }
    });
  }

  function buildLoadMore(query, nextPage, remaining) {
    return '<button type="button" class="search-drawer__ver-mas" data-ver-mas data-page="' + nextPage + '" data-remaining="' + remaining + '">' +
      'Ver más (' + remaining + ')</button>';
  }

  function bindLoadMore(query, page) {
    var btn = resultsContainer.querySelector('[data-ver-mas]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var p = parseInt(btn.getAttribute('data-page'));
      btn.textContent = 'Loading...';
      btn.disabled = true;
      fetchSearchPage(query, p, function (newCardsHtml, totalCount) {
        btn.remove();
        allProducts = allProducts.concat(newCardsHtml);
        var grid = resultsContainer.querySelector('.search-drawer__products');
        grid.insertAdjacentHTML('beforeend', newCardsHtml.join(''));
        var nextP = p + 1;
        if (allProducts.length < totalCount) {
          resultsContainer.insertAdjacentHTML('beforeend', buildLoadMore(query, nextP, totalCount - allProducts.length));
          bindLoadMore(query, nextP);
        }
      });
    });
  }

  function fetchSearchPage(query, page, callback) {
    var url = searchUrlBase + '?q=' + encodeURIComponent(query) + '&page=' + page + '&section_id=main-search';
    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    })
    .then(function (html) {
      var temp = document.createElement('div');
      temp.innerHTML = html;
      var cards = temp.querySelectorAll('product-card');
      var productsGrid = temp.querySelector('.search-page__products');
      var total = parseInt(productsGrid ? productsGrid.getAttribute('data-total') : '0') || 0;
      var cardsHtml = [];
      cards.forEach(function (card) {
        cardsHtml.push(card.outerHTML);
      });
      if (total === 0) total = cardsHtml.length;
      callback(cardsHtml, total);
    })
    .catch(function () {
      var btn = resultsContainer.querySelector('[data-ver-mas]');
      if (btn) {
        btn.textContent = 'View all results';
        btn.disabled = false;
      }
    });
  }

  function buildProductGrid(products, wrap) {
    if (wrap === undefined) wrap = true;
    var html = wrap ? '<div class="search-drawer__products">' : '';
    products.forEach(function (item) {
      var title = item.title || '';
      var url = item.url || '#';
      var imgUrl = '';
      if (typeof item.image === 'string') {
        imgUrl = item.image;
      } else if (item.featured_image && item.featured_image.url) {
        imgUrl = item.featured_image.url;
      } else if (item.image) {
        imgUrl = item.image;
      }
      var price = item.price || item.price_min || '';
      if (price && item.price === item.price) {
        if (typeof price === 'string' && price.indexOf('$') === -1 && isNaN(price)) {
          price = '';
        }
      }
      html += '<product-card class="product-card">';
      html += '<div class="product-card__figure">';
      if (imgUrl) {
        if (imgUrl.indexOf('//') === 0) imgUrl = 'https:' + imgUrl;
        html += '<a href="' + escapeHtml(url) + '" class="product-card__image--primary" data-instant>';
        html += '<img src="' + escapeHtml(imgUrl) +
          '" alt="' + escapeHtml(title) + '" loading="lazy" class="product-card__image" style="width:100%;display:block;aspect-ratio:3/4;object-fit:cover;background:#f9f9f9">';
        html += '</a>';
      }
      html += '</div>';
      html += '<div class="product-card__info empty:hidden">';
      html += '<div class="v-stack justify-items-center gap-2">';
      html += '<div class="v-stack justify-items-center gap-1">';
      html += '<a href="' + escapeHtml(url) + '" class="product-title" data-instant>' + escapeHtml(title) + '</a>';
      if (price) {
        html += '<span class="price-list">' + formatMoney(price) + '</span>';
      }
      html += '</div></div></div>';
      html += '</product-card>';
    });
    if (wrap) html += '</div>';
    return html;
  }

  function bindResultEvents(products, suggestions, query) {
    var viewAll = resultsContainer.querySelector('[data-view-all]');
    if (viewAll) {
      viewAll.addEventListener('click', function () {
        loadFullView(query);
      });
    }

    resultsContainer.querySelectorAll('[data-search-tag]').forEach(function (tag) {
      tag.addEventListener('click', function () {
        input.value = tag.textContent.trim();
        onInput();
      });
    });
  }

  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function formatMoney(amount) {
    if (!amount) return '';
    if (typeof amount === 'string') amount = parseFloat(amount);
    if (amount > 0 && amount < 1) return '$' + amount.toFixed(2);
    if (amount >= 10000) amount = amount / 100;
    return '$' + amount.toFixed(2);
  }

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    init();
  }

  document.addEventListener('click', function (e) {
    var searchLink = e.target.closest('[aria-controls="search-drawer"]');
    if (searchLink) {
      e.preventDefault();
      if (isOpen) {
        close();
      } else {
        open();
      }
    }
  });
})();
